import { Text } from '@southfields-digital/mxmz-react-ui';
import { useEffect, useMemo } from 'react';

import { MatchControlButton, MatchControlIcon } from 'src/components/MatchControl/components';
import { useTimer } from 'src/components/MatchControl/hooks';
import { getFormattedTime } from 'src/components/MatchControl/utils';
import { PenaltyClock } from 'src/types/matchControl/clock';

type PenaltyClockItemProps = {
  penaltyClock: PenaltyClock;
  handleDeleteClock: () => void;
};

const PenaltyClockItem = ({ penaltyClock, handleDeleteClock }: PenaltyClockItemProps) => {
  const { time, setTimer } = useTimer(
    250,
    penaltyClock.clockTime,
    penaltyClock.clockCountDirection
  );

  useEffect(() => {
    if (!penaltyClock) return;

    const clock = penaltyClock;
    const serverTimeOffset = clock.serverTimeUpdate
      ? new Date(clock.serverTimeUpdate).getTime() - Date.now()
      : 0;

    const startedAt = clock.clockTimeUpdatedAt
      ? new Date(clock.clockTimeUpdatedAt).getTime() - serverTimeOffset
      : null;

    setTimer(clock.clockTime ?? 0, startedAt ? new Date(startedAt) : null);
  }, [penaltyClock]);

  const formattedTime = useMemo(() => getFormattedTime(time, 'minutes', true), [time]);

  return (
    <div className="flex flex-row items-center gap-2 text-white w-full">
      <Text className="flex-1 w-[45px] bg-gray-900 text-white text-center font-mono">
        {formattedTime}
      </Text>
      <MatchControlButton variant="icon" onClick={handleDeleteClock}>
        <MatchControlIcon iconProps={{ icon: 'x' }} />
      </MatchControlButton>
    </div>
  );
};

export default PenaltyClockItem;
